module.exports = __webpack_public_path__ + "media/images/Jcrop-7a4b4c6ebdb549fcbe47408f9457493e.gif";